import * as React from 'react';
import { Stack, Grid, Typography, useTheme, useMediaQuery, Box, Link as MUILink } from '@mui/material';
import Logo from '../../components/ui/Logo';
import { Link } from 'react-router-dom';
import SignInImg from '../../assets/images/signin.png';

export type PublicLayoutProps = {
    children: React.ReactNode;
    showLogo?: boolean;
};

export default function PublicLayout({ children, showLogo = true }: PublicLayoutProps): JSX.Element {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Grid container justifyContent={matchDownSM ? 'center' : 'space-between'} alignItems="center">
            <Grid item md={6} lg={7} xs={12} sx={{ minHeight: '100vh' }}>
                <Grid
                    sx={{ minHeight: '100vh' }}
                    container
                    alignItems={matchDownSM ? 'center' : 'flex-start'}
                    justifyContent={matchDownSM ? 'center' : 'space-between'}
                >
                    {showLogo && (
                        <Grid item sx={{ display: { xs: 'none', md: 'block' }, m: 3 }}>
                            <Link to="/">
                                <Logo />
                            </Link>
                        </Grid>
                    )}

                    {children}
                    <Grid item xs={12} sx={{ m: 3 }}>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography
                                variant="subtitle2"
                                component={MUILink}
                                href="https://www.fwscience.us"
                                target="_blank"
                                underline="hover"
                            >
                                www.fwscience.us
                            </Typography>
                            <Typography variant="subtitle2">2024 &copy; Framework Science</Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item md={6} lg={5} sx={{ position: 'relative', alignSelf: 'stretch', display: { xs: 'none', md: 'block' } }}>
                <Box
                    component="img"
                    src={SignInImg}
                    alt="Sign In Img"
                    sx={{ display: 'flex', height: '100vh', minHeight: '100%', width: '100%' }}
                />
            </Grid>
        </Grid>
    );
}
